<div class="test-logic-container">
  <div class="header">
    <h3>{{ "campaign.outcomes.test-logic.title" | translate }}</h3>
  </div>

  <div class="test-logic-description">
    <p>{{ "campaign.outcomes.test-logic.description" | translate }}</p>
  </div>

  <div class="scrollable-content">
    <div class="check-logic-row">
      <div class="toggles">
        <mat-slide-toggle [(ngModel)]="showOnlyUsedInputs">{{ "campaign.outcomes.test-logic.hide-unused" | translate }}</mat-slide-toggle>
      </div>
    </div>

    <div class="test-inputs-container">
      @for (component of filteredRegularInputs; track component) {
        <div class="test-input-item">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ component.displayName }}</mat-label>
            @if (component.values?.length > 0) {
              <mat-select [(ngModel)]="testInputs[component.name]" (ngModelChange)="onTestInputChange()" [multiple]="component.isMultiSelect">
                <mat-select-trigger>
                  @if (getSelectedItems(component).length > 0) {
                    <div class="trigger-content">
                      @if (!component.isMultiSelect) {
                        @if (getSelectedItems(component)[0]; as item) {
                          <div class="label-with-icon">
                            <span class="text-truncate">{{ item.value }}</span>
                            @if (item.isCorrect) {
                              <mat-icon class="check-icon">check</mat-icon>
                            }
                            @if (item.score !== 0) {
                              <span class="score-text-trigger">{{ item.score > 0 ? "+" : "" }}{{ item.score }}</span>
                            }
                          </div>
                        }
                      }
                      @if (component.isMultiSelect) {
                        @for (item of getSelectedItems(component); track item; let last = $last) {
                          <span>
                            {{ item.value }}
                            @if (item.score !== 0) {
                              <span>{{ item.score > 0 ? "+" : "" }}{{ item.score }}</span>
                            }
                            @if (!last) {
                              <span>,</span>
                            }
                          </span>
                        }
                      }
                    </div>
                  }
                </mat-select-trigger>
                @for (item of component.valuesWithScore; track item) {
                  <mat-option [value]="item.value">
                    <div class="option-content">
                      <div class="label-with-icon">
                        <span class="text-truncate">{{ item.value }}</span>
                        @if (item.isCorrect) {
                          <mat-icon class="check-icon" matTooltipPosition="above" [matTooltip]="'campaign.widget.component.score.is-correct' | translate">
                            check
                          </mat-icon>
                        }
                        @if (item.score !== 0) {
                          <span class="score-text">Score: {{ item.score > 0 ? "+" : "" }}{{ item.score }}</span>
                        }
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-select>
            }
            @if (!component.values?.length) {
              <input matInput [(ngModel)]="testInputs[component.name]" (ngModelChange)="onTestInputChange()" />
            }
          </mat-form-field>
        </div>
      }
    </div>
  </div>

  <div class="sticky-footer">
    <div class="score-row">
      @if (showScoreInput) {
        <div class="score-input-container">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            @if (hasScore) {
              <mat-label>{{ scoreInput?.displayName }} (min {{ minScore }}, max {{ maxScore }})</mat-label>
            }
            @if (!hasScore) {
              <mat-label>Score (No score available)</mat-label>
            }
            @if (hasScore) {
              <input matInput [(ngModel)]="testInputs[scoreInput?.name]" (ngModelChange)="onTestInputChange()" type="number" />
            }
            @if (!hasScore) {
              <input matInput disabled value="" />
            }
          </mat-form-field>
        </div>
      }
    </div>
  </div>
</div>
